//import { normalizeDbData } from "../helpers";

import api from "./api";
// import { a } from "@/src/helpers";

export async function getEstablishmentTypes(): Promise<any | null> {
    return await api
        .get("api/establishment-type/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentGroups(): Promise<any | null> {
    return await api
        .get("api/establishment-group/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentBySiret(
    siret: string
): Promise<any | null> {
    return await api
        .get("/api/establishment-by-siret/" + siret)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentById(
    establishementId: number
): Promise<any | null> {
    return await api
        .get("/api/establishment/" + establishementId)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function putEstablishment(
    establishement: any
): Promise<any | null> {
    return await api
        .put("/api/establishment/" + establishement.id, establishement)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentStatus(): Promise<any | null> {
    return await api
        .get("api/establishment-status/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentByIds(
    establishementIds: number[]
): Promise<any | null> {
    return await api
        .get("/api/establishment/?ids=" + establishementIds.join(","))
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getEstablishmentsByGroupOrRegion(
    groupId: number,
    regionId?: number
): Promise<any | null> {
    const url = regionId
        ? `api/establishment/?group_id=${groupId}&region_id=${regionId}`
        : `api/establishment/?group_id=${groupId}`;

    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getRegionById(id: number): Promise<any | null> {
    let url = `api/establishment/region/${id}`;
    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }

            return error;
        });
}

export async function getNetworkById(id: number): Promise<any | null> {
    let url = `api/establishment-group/${id}`;
    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }

            return error;
        });
}

export async function getRegionList(): Promise<any | null> {
    return await api
        .get("api/region/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
